import React, { Component } from 'react';
import {ref} from '../config/firebase';
import Nav from './components/Nav';
import Footer from './components/Footer';
import {Tabs, Tab} from 'react-bootstrap';

import Error from '../helpers/Error';

export default class Skills extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aKey: 1,
			key : '',
			category: '',
			itemsIT: [],
			itemsMgmt: [],
			edit: false,
			err: null,
			status: null
		};
		this.dbItems = ref.child('skills');
		this.handleSkillSubmit = this.handleSkillSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
	}


	componentDidMount() {
		this.dbItems.child("it").on('value', dataSnapshot => {
			var items = [];
			dataSnapshot.forEach(function(childSnapshot) {

				var item = childSnapshot.val();
				
				item['.key'] = childSnapshot.key;
				
				items.push(item);

			});

			this.setState({itemsIT: items});

		});

		this.dbItems.child("mgmt").on('value', dataSnapshot => {
			var items = [];
			dataSnapshot.forEach(function(childSnapshot) {

				var item = childSnapshot.val();
				
				item['.key'] = childSnapshot.key;
				
				items.push(item);

			});

			this.setState({itemsMgmt: items});

		});

		
	}

	handleSkillSubmit(e) {
		e.preventDefault();

		if(this.skill_name.value !== "" && this.skill_lvl.value !== "" && this.skill_category.value !== "") {
			
			if(this.state.edit) { // edit
				this.dbItems.child(this.state.category + '/' + this.state.key).update({
					skill_name: this.skill_name.value,
					skill_lvl:  this.skill_lvl.value
				});
				this.setState({
					err: "Success Edit Skill!",
					status: null,
					edit: false,
					category: '',
					key: ''
				});
				this.handleSelect(1);
			}
			else { // create
				this.dbItems.child(this.skill_category.value).push({
					skill_name: this.skill_name.value,
					skill_lvl:  this.skill_lvl.value
				})

				this.setState({err: "Success Insert New Skill!", status: null});
			}

			this.skill_category.value = '';
			this.skill_name.value = '';
			this.skill_lvl.value = '';
			
		}
		else {
			this.setState({err: "Something Wrong", status:'err'});
		}

	}

	removeItem(category, key) {
		this.dbItems.child(category + '/' + key).remove();
	}

	editItem(category, key) {
		this.dbItems.child(category + '/' +key).once('value', dataSnapshot => {

			var data = dataSnapshot.val();

			// set back value
			this.skill_category.value = category;
			this.skill_name.value = data.skill_name;
			this.skill_lvl.value = data.skill_lvl;
			
			this.handleSelect(3);

			this.setState({
				edit:true,
				category: category,
				key: key
			});
		});

		
	}

	componentWillUnmount() {
		this.dbItems.off();
	}

	mapSkills(lvl) {
		var aLvl = parseInt(lvl, 10);
		return (aLvl === 1) ? 'Good' : (aLvl === 2)? 'Fair' : 'Fluent';
	}

	handleSelect(aKey) {
		this.setState({aKey});
	}

  render () {
  	var dat = [ 'IT Skills', 'Management Skills', 'Create Skills' ];
  	var i = 0;
  	var j = 0;
  	var _this = this;

    return (
    	<div>
    		<Nav />
    		<div className="container">
    			<div className="row">
    				<h1>SKILLS</h1>
    				<Error err={this.state.err} status={this.state.status}/>
    				<Tabs activeKey={this.state.aKey} onSelect={this.handleSelect} id="skillTab">
    					<Tab eventKey={1} title={dat[0]}>
							<h3>{dat[0]}</h3>
						    <table className="table table-bordered">
								<thead>
									<tr>
										<th>No</th>
										<th>Skills Name</th>
										<th>Skills Level</th>
										<th>Action</th>
									</tr>
								</thead>

								<tbody>
									{
										this.state.itemsIT.map(function(item) {

											return (
												<tr key={item['.key']}>
													<td>{++i}.</td>
													<td>{item.skill_name}</td>
													<td>{_this.mapSkills(item.skill_lvl)}</td>
													<td>
														<a data-toggle="tab" className="btn btn-info" href="#create" onClick={()=>{_this.editItem("it", item['.key'])}}>Edit</a> &nbsp;
														<a className="btn btn-danger" onClick={() => { _this.removeItem("it", item['.key']) }}>Delete</a>
													</td>
												</tr>
											);
										})
									}
									
								</tbody>
							</table>
    					</Tab>
    					
    					<Tab eventKey={2} title={dat[1]}>
    						<h3>{dat[1]}</h3>
						    <table className="table table-bordered">
								<thead>
									<tr>
										<th>No</th>
										<th>Skills Name</th>
										<th>Skills Level</th>
										<th>Action</th>
									</tr>
								</thead>

								<tbody>
									{
										this.state.itemsMgmt.map(function(item) {

											return (
												<tr key={item['.key']}>
													<td>{++j}.</td>
													<td>{item.skill_name}</td>
													<td>{_this.mapSkills(item.skill_lvl)}</td>
													<td>
														<a data-toggle="tab" className="btn btn-info" href="#create" onClick={()=>{_this.editItem("mgmt", item['.key'])}}>Edit</a> &nbsp;
														<a className="btn btn-danger" onClick={() => { _this.removeItem("mgmt", item['.key']) }}>Delete</a>
													</td>
												</tr>
											);
										})
									}
									
								</tbody>
							</table>
    					</Tab>

    					<Tab eventKey={3} title={(this.state.edit)? 'Edit Skills' : dat[2]}>
							<h3>{(this.state.edit)? 'Edit Skills' : dat[2]}</h3>
						    <form onSubmit={this.handleSkillSubmit}>
			        			<div className="form-group">
								    <label>Skill Category</label>
								    <select disabled={this.state.category !== ''} className="form-control" ref={(skill_category)=>this.skill_category=skill_category}>
										<option value="">-Skill Category-</option>
										<option value="it">IT Skills</option>
										<option value="mgmt">Management Skills</option>
								    </select>
								  </div>
							  <div className="form-group">
							    <label>Skill Name</label>
							    <input type="text" ref={(skill_name) => this.skill_name = skill_name} className="form-control" placeholder="Ex: React.JS"/>
							  </div>
							  <div className="form-group">
							    <label>Level of Skill</label>
							    <input type="number" ref={(skill_lvl)=>this.skill_lvl=skill_lvl} className="form-control" placeholder="1: Good,2: Fair, 3: Fluent"/>
							  </div>
							  	
							  <button type="submit" className="btn btn-default">{(this.state.edit)?'Edit':'Create'}</button> &nbsp;
							  <button type="reset" className="btn btn-warning">Cancel</button>
							</form>
    					</Tab>
    				</Tabs>
		    		
				</div>
			</div>
			<Footer/>
    	</div>
      
    )
  }
}


// WEBPACK FOOTER //
// ./src/auth_pages/Skills.js